import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";

const STATES = ["Andhra Pradesh","Assam","Bihar","Delhi","Goa","Gujarat","Haryana","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Punjab","Rajasthan","Tamil Nadu","Telangana","Uttar Pradesh","West Bengal"];

export default function Customers() {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: "", gstin: "", state: "Maharashtra", email: "", phone: "", address: "" });

  const load = async () => setRows((await api.get("/customers")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/customers", form);
      toast.success("Customer added");
      setShow(false);
      setForm({ name: "", gstin: "", state: "Maharashtra", email: "", phone: "", address: "" });
      load();
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!confirm("Delete this customer?")) return;
    await api.delete(`/customers/${id}`);
    load();
  };

  return (
    <div className="space-y-5 lb-fade" data-testid="customers-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Master</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Customers</h1>
        </div>
        <button className="lb-btn" onClick={() => setShow((s) => !s)} data-testid="add-customer-btn">
          <Plus size={14} /> New Customer
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="lb-card p-6 grid grid-cols-3 gap-4" data-testid="customer-form">
          <div className="col-span-2">
            <label className="lb-label">Name</label>
            <input required className="lb-input" data-testid="cf-name"
                   value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label className="lb-label">GSTIN (optional)</label>
            <input className="lb-input font-mono uppercase" maxLength={15} data-testid="cf-gstin"
                   value={form.gstin} onChange={(e) => setForm({ ...form, gstin: e.target.value.toUpperCase() })} />
          </div>
          <div>
            <label className="lb-label">State</label>
            <select required className="lb-select" data-testid="cf-state"
                    value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })}>
              {STATES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="lb-label">Email</label>
            <input type="email" className="lb-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="lb-label">Phone</label>
            <input className="lb-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div className="col-span-3">
            <label className="lb-label">Address</label>
            <textarea className="lb-textarea" rows={2} value={form.address}
                      onChange={(e) => setForm({ ...form, address: e.target.value })} />
          </div>
          <div className="col-span-3 flex gap-2">
            <button className="lb-btn" data-testid="cf-submit">Save</button>
            <button type="button" className="lb-btn lb-btn-ghost" onClick={() => setShow(false)}>Cancel</button>
          </div>
        </form>
      )}

      <div className="lb-card">
        <table className="lb-table">
          <thead>
            <tr><th>Name</th><th>GSTIN</th><th>State</th><th>Email</th><th>Phone</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.name}`}>
                <td className="font-semibold">{c.name}</td>
                <td className="font-mono text-xs">{c.gstin || "—"}</td>
                <td className="text-sm">{c.state}</td>
                <td className="text-sm">{c.email}</td>
                <td className="text-sm">{c.phone}</td>
                <td><button onClick={() => del(c.id)} className="text-neutral-500 hover:text-rose-600"><Trash size={14} /></button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="text-center py-10 text-neutral-500">No customers</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
